import { createContext, useContext, type ReactNode } from "react";
import { useLiveCTAPoll, type LiveCTAState } from "@/hooks/useLiveCTA";

const DualCtaLiveContext = createContext<LiveCTAState | null>(null);

/**
 * Poll compartido de variantes dual CTA (mux + labels + visibility).
 * Solo montar en superficies de membresía / US intl:
 *   DualCTAVideoLanding · USExclusiveLanding · VideoTemplate
 *
 * BaseTemplate (AR home) usa `useLiveCTA()` directo para hero CTA — sin dual variant poll.
 */
export function DualCtaLiveProvider({ children }: { children: ReactNode }) {
  const value = useLiveCTAPoll();
  return <DualCtaLiveContext.Provider value={value}>{children}</DualCtaLiveContext.Provider>;
}

export function useDualCtaLive(): LiveCTAState {
  const ctx = useContext(DualCtaLiveContext);
  if (!ctx) {
    throw new Error(
      "useDualCtaLive must be used within DualCtaLiveProvider (DualCTAVideoLanding, USExclusiveLanding, VideoTemplate)",
    );
  }
  return ctx;
}

export type { LiveCTAState };
